import {Injectable} from '@angular/core';
import {EntityState, EntityStore, StoreConfig} from '@datorama/akita';
import {Reseller} from './model';

export interface ResellerState extends EntityState<Reseller> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'Reseller' })
export class Store extends EntityStore<ResellerState> {

  constructor() {
    super();
  }

}
